import { QueryFunction } from 'react-query';

import { PriceOptionType, PriceOptionWithInfo } from 'app/modules/PriceOptions/PriceOption';
import { TranslationQuote, TranslationQuoteData } from 'app/modules/TranslationQuote/TranslationQuote';
import { AvailableCurrency } from 'app/translations/timezones';
import { GetFunction, httpClient, PostFunction } from 'pkg/httpClient/httpClient';

const TRANSLATION_QUOTE_URL = '/quote/translation';
const TRANSLATION_QUOTE_PRICING_URL = (id: string, currency: string) =>
  `/quote/translation/pricing?id=${id}&currency=${currency}`;
const TRANSLATION_QUOTE_ORDER_NOW_URL = '/quote/translation/order';

const TRANSLATION_QUOTE_KEY = 'translationQuote';

interface TranslationQuoteApi {
  queryKey: string;
  post: (translationQuote: TranslationQuoteData) => Promise<TranslationQuote>;
  getPricing: QueryFunction<PriceOptionWithInfo, [string, string, string]>;
  orderNow: (data: {
    option: PriceOptionType;
    currency: AvailableCurrency;
    quoteId: string;
    totalPrice: number;
  }) => Promise<unknown>;
}

const translationQuoteApiFactory = (client: { get: GetFunction; post: PostFunction }): TranslationQuoteApi => ({
  queryKey: TRANSLATION_QUOTE_KEY,
  post: (quote: TranslationQuoteData) =>
    client.post<TranslationQuoteData, TranslationQuote>(TRANSLATION_QUOTE_URL, quote).then(({ data }) => data),
  getPricing: ({ queryKey }) =>
    client.get<PriceOptionWithInfo>(TRANSLATION_QUOTE_PRICING_URL(queryKey[1], queryKey[2])).then(({ data }) => data),
  orderNow: (data) =>
    client.post<{ option: PriceOptionType; currency: AvailableCurrency; quoteId: string }, void>(
      TRANSLATION_QUOTE_ORDER_NOW_URL,
      data
    ),
});

const translationQuoteApi = translationQuoteApiFactory(httpClient);

export { translationQuoteApi, translationQuoteApiFactory };
